<template>
  <div class="dashboard">
    <!-- 顶部导航栏 -->
    <div class="custom-header">
      <div class="header-left">
        <img :src="imgSrc" class="header-logo" />
        <div class="header-title">智能 · 高效</div>
      </div>
      <div class="header-right" @click="exitPage">
        <van-icon class="iconfont icon-chuqudengji" size="20" color="#fff" />
      </div>
    </div>

    <div class="content">
      <template v-if="loading">
        <div class="loading-wrapper">
          <van-loading type="spinner" size="40" vertical>
            加载中...
          </van-loading>
        </div>
      </template>

      <template v-else>
        <div class="welcome-card">
          <div class="welcome-title">欢迎回来 {{v_usernm}}</div>
          <div class="welcome-subtitle">今天有 {{ totalPending }} 个待处理事项</div>
          <div class="welcome-date">
            <van-icon name="calendar-o" />
            <span>{{ currentDate }}</span>
          </div>
        </div>

        <div class="approval-section">
          <div class="section-title">待审批单据</div>
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="approval-list">
            <div
                v-for="item in approvalList"
                :key="item.id"
                class="approval-item"
                @click="goToApprovalDetail(item)"
            >
              <div class="approval-icon" :style="{ backgroundColor: '#8ab1b8' }">
                <van-icon :class="item.icon" size="24" color="#fff" />
              </div>
              <div class="approval-content">
                <div class="approval-title">{{ item.title }}</div>
                <div class="approval-count"><span >{{ item.count }}</span> 个待处理</div>
              </div>
              <van-icon name="arrow" color="#c8c9cc" />
            </div>
          </van-pull-refresh>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getDate } from '@/api/tools'

export default {
  name: 'Dashboard',
  data() {
    return {
      currentDate: '',
      v_username: this.$cookies.get('v_telno'),
      v_usernm: this.$cookies.get('v_usernm'),
      v_corpid: this.$cookies.get('v_corpid'),
      imgSrc: require("@/assets/title.png"),
      approvalList: [],
      allApprovalList: [],
      loading: false,
      refreshing: false
    }
  },
  computed: {
    totalPending() {
      return this.allApprovalList.length
    }
  },
  
  mounted() {
    if (!this.v_username) {
      this.$router.push({ path: '/login' })
      return
    }
    this.currentDate = getDate('day')
    // 获取待审批数据并进行分类
    this.waitList()
  },
  methods: {
    // 下拉刷新
    onRefresh() {
      // 更新当前日期
      this.currentDate = getDate('day')
      
      // 重新加载数据
      this.waitList().then(() => {
        this.refreshing = false
        this.$toast.success('刷新成功')
      }).catch(() => {
        this.refreshing = false
        this.$toast.fail('刷新失败')
      })
    },

    // 跳转到审批详情
    goToApprovalDetail(item) {

      const routeMap = {
        expense: '/approval/expense/list',
        purchase: '/approval/purchase/list',
        sales: '/approval/sales/list',
        forecast: '/approval/forecast/list',
      }

      const targetPath = routeMap[item.type] || '/approval/list'

      this.$router.push({
        path: targetPath,
        query: { type: item.type }
      })
    },

    //待审核列表
    waitList(){
      // 只在首次加载时显示 loading，刷新时不显示
      if (!this.refreshing) {
        this.loading = true
      }
      
      let v_chk =' or (ty=\'RECEIVE\' and chkdttm is null and appuser=\''+this.v_username+'\') '+' or (ty=\'SKUFEE\' and appdttm is null and telno1=\''+this.v_username+'\') '+' or (ty=\'SKUFEE\' and chkdttm is null and telno2=\''+this.v_username+'\') '
      v_chk =v_chk+' or (ty=\'CONFIRM\' and ((nodttm1 is null and telno1=\''+this.v_username+'\') or (nodttm2 is null and telno2=\''+this.v_username+'\') or (nodttm3 is null and telno3=\''+this.v_username+'\') or (nodttm4 is null and telno4=\''+this.v_username+'\') or (nodttm5 is null and telno5=\''+this.v_username+'\')))'
      let v_cond ='select * from V_WAIT_CONFIRM a where a.corpid=\''+this.v_corpid+'\' and ((ty=\'FREE\')'+v_chk+' OR exists(select null from V_CHKUSER where fruser is null and chkuser1=\''+this.v_username+'\' and ty=a.ty AND TY!=\'FINFEE\') or exists(select null from V_FLOW_CFM where idseq=a.idseq and userno=\''+this.v_username+'\') )'
      
      return this.$axios({
        method: 'post',
        url:'xuper_auth/getFreeData',
        data: {p_cond: v_cond +' order by seq,idty,dttm desc'},
      }).then(res=>{
        if (res.code === '200') {
          this.allApprovalList = res.result || []

          // 定义允许显示的类型及其默认图标和模拟数据
          const typeConfigs = [
            {
              key: '报销-管理摊分',
              type: 'expense',
              icon: 'iconfont icon-baoxiaodan',
              color: '#8ab1b8',

            },
            {
              key: '采购订单',
              type: 'purchase',
              icon: 'iconfont icon-PurchasingRecords',
              color: '#8ab1b8',
  
            },
            {
              key: '销售订单',
              type: 'sales',
              icon: 'iconfont icon-zcpt-xiaoshouguanli',
              color: '#8ab1b8',

            },
            {
              key: '预测单',
              type: 'forecast',
              icon: 'iconfont icon-dingdan',
              color: '#8ab1b8',

            }
          ]

          // 如果接口返回空数组，不插入模拟数据
          // if (this.allApprovalList.length === 0) {
          //   this.allApprovalList = typeConfigs.map(config => config.mockData)
          // }

          // 按 IDTY 分组统计数量
          const groupedData = {}
          
          // 遍历所有待审批数据，根据 IDTY 进行分组
          this.allApprovalList.forEach(item => {
            const idty = item.IDTY
            const config = typeConfigs.find(c => c.key === idty)
            
            if (config) {
              if (!groupedData[idty]) {
                groupedData[idty] = {
                  title: idty,
                  count: 0,
                  data: [],
                  icon: item.ICON || config.icon,
                  color: config.color,
                  type: config.type
                }
              }
              groupedData[idty].count++
              groupedData[idty].data.push(item)
            }
          })

          // 转换为数组
          this.approvalList = typeConfigs.map((config, index) => {
            if (groupedData[config.key]) {
              return {
                id: index + 1,
                ...groupedData[config.key]
              }
            } else {
              // 没有该类型数据，显示 0
              return {
                id: index + 1,
                title: config.key,
                count: 0,
                data: [],
                icon: config.icon,
                color: config.color,
                type: config.type
              }
            }
          })
        }
        return Promise.resolve()
      }).catch(err => {
        this.$toast.fail('加载数据失败')
        return Promise.reject(err)
      }).finally(() => {
        this.loading = false
      })
    },

    // 退出系统
    exitPage() {
      this.$dialog.confirm({
        title: '提示',
        message: '你确定要退出系统吗?',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.$store.dispatch('logout')
        this.$router.push({ path: '/login' })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f7f8fa;
}

.custom-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 16px;
  background: #235eff;
  color: #fff;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(35, 94, 255, 0.15);
}

.header-left {
  display: flex;
  align-items: center;
}

.header-logo {
  width: 120px;
  height: 40px;
  margin-right: 12px;
  object-fit: contain;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
}

.header-right {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 8px;
  cursor: pointer;

  transition: opacity 0.2s;

  &:active {
    opacity: 0.7;
  }
}

/* ================= content ================= */

.content {
  flex: 1;
  margin-top: 56px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
}

/* ================= loading ================= */

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
}

/* ================= welcome card ================= */

.welcome-card {
  margin: 16px;
  padding: 20px 16px;

  border-radius: 10px;

  color: #fff;

  background: linear-gradient(135deg, #5f86f1 0%, #8fcfea 100%);

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.welcome-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 6px;
}

.welcome-subtitle {
  font-size: 16px;
  margin-bottom: 10px;
  opacity: 0.95;
}

.welcome-date {
  display: flex;
  align-items: center;
  font-size: 14px;
  opacity: 0.9;
}

.welcome-date .van-icon {
  margin-right: 4px;
  font-size: 12px;
}

.approval-section {
  flex: 1;
  padding: 0 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
  line-height:34px;background:#fff;
  height:34px;
  padding-left:8px;
  border-left:4px solid #409eff;
}

/* list */

.approval-list {
  min-height: 300px;
}

::v-deep .van-pull-refresh__track {
  min-height: 100%;
}

/* ================= item ================= */

.approval-item {
  display: flex;
  align-items: center;

  padding: 12px 16px;
  margin-bottom: 10px;

  background: #fff;

  border-radius: 10px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  transition: transform 0.1s;
}

.approval-item:active {
  transform: scale(0.98);
  background: #f7f8fa;
}

/* icon */

.approval-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 40px;

  margin-right: 12px;

  border-radius: 12px;

  background: linear-gradient(135deg, #8fcfea 0%, #427bec 100%);

  flex-shrink: 0;
}

/* content */

.approval-content {
  flex: 1;
  min-width: 0;
}

.approval-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.approval-count {
  font-size: 12px;
  color: #999;
}

/* arrow */

.approval-item .van-icon {
  margin-left: 6px;
  flex-shrink: 0;
}
</style>
